import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "affix-container",
  id: "imgtrans_head_container"
};
const _hoisted_2 = {
  id: "imgtrans_head",
  style: {
    "height": "100%",
    "background-color": "white"
  }
};
const _hoisted_3 = {
  style: {
    "height": "100%",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
  const _component_van_row = _resolveComponent("van-row");
  const _component_el_affix = _resolveComponent("el-affix");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_affix, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_row, {
      justify: "space-between",
      style: {
        "height": "100%"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: "6",
        style: {
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
          style: {
            "height": "100%",
            "vertical-align": "top"
          },
          src: $setup.logoimg,
          alt: "Amalia logo",
          "object-fit": "cover",
          onClick: _cache[0] || (_cache[0] = $event => $options.handelclick(0))
        }, null, 8, _hoisted_4)])]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "8",
        style: {
          "height": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_dropdown_menu, {
          ref: "menuRef",
          style: {
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
            class: "dropdown-item",
            modelValue: $setup.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.value = $event),
            options: $setup.options,
            title: $setup.options[$data.selectindex].text,
            onClick: _cache[2] || (_cache[2] = $event => $options.handelclick($setup.value)),
            onChange: _cache[3] || (_cache[3] = $event => $options.handlechange($setup.value))
          }, null, 8, ["modelValue", "options", "title"])]),
          _: 1
        }, 512)]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  })]);
}